import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-public-transport',
  templateUrl: './public-transport.page.html',
  styleUrls: ['./public-transport.page.scss'],
})
export class PublicTransportPage {
  //declared variables
  public assets = environment.assets;
  public station: any;
  // constructor
  constructor() {
    this.station = 'west';
  }
}
